module.exports = {"id":"187666","name":"Sergey Pesyakov","rating":"72","photo":"./data/images/photos/3/187666.png","club":{"name":"FK Rostov","logo":"./data/images/clubs/FKRostov.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SergeyPesyakov0.json
// module id = 3902
// module chunks = 0